import FetchSchema from '../function/schema.js'

export default class GenerateSchema extends FetchSchema {}
